import { useEffect } from "react";
import { observer } from "mobx-react";
import { useParams } from "react-router";
import { ValuationPayment } from "./valuationPaymentModule";
import { useStore } from "../../hooks";
import NoPaymentAvailable from "./noPaymentAvailable";
import PaymentNotAvailable from "./paymentNotAvailable";

type ValuationPaymentParams = {
  token: string;
};

export const ValuationPaymentContainer = observer(() => {
  const { token } = useParams<ValuationPaymentParams>();
  const { valuationPaymentStore } = useStore();

  useEffect(() => {
    if (!valuationPaymentStore.token) {
      valuationPaymentStore.setToken(token);
    }

    valuationPaymentStore.fetchValuationInfo();
  }, []);

  if (valuationPaymentStore.pendingPayment === false) {
    return <NoPaymentAvailable />;
  }

  if (valuationPaymentStore.hasZeroAppraisalFee()) {
    return <PaymentNotAvailable />;
  }

  return <ValuationPayment />;
});
